import script from "./Content.vue?vue&type=script&setup=true&lang=js"
export * from "./Content.vue?vue&type=script&setup=true&lang=js"

import "../../styles/KickbackFeeContent.scss?vue&type=style&index=0&id=2a88e55e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a88e55e"]])

export default __exports__